// tslint:disable:max-line-length

import React from 'react';

export const StatusBlocked = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,2c1.1,0,2.1,0.3,3,0.8L2.8,11C2.3,10.1,2,9.1,2,8C2,4.7,4.7,2,8,2 z M8,14c-1.1,0-2.1-0.3-3-0.8L13.2,5C13.7,5.9,14,6.9,14,8C14,11.3,11.3,14,8,14z" />
    </svg>
  );
};
